import { Component, HostListener } from '@angular/core';
import { ThemeToggleService } from '../../services/theme-Toggle/theme-toggle.service';
import { NavigationEnd, Router, RouterOutlet, RouterLinkActive, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  navType,
} from '../../services/config/app-config.service';

@Component({
  selector: 'app-landing-page',
  imports: [RouterOutlet, CommonModule, RouterLinkActive, RouterLink],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
  selectedNavIndex: Number = 0;
  public themeStyles: any;
  userDetails: any = {};
  showThemes: boolean = false;
  public navBar: navType[] = [];
  constructor(
    private themeToggleService: ThemeToggleService,
    private router: Router
  ) {
    this.themeToggleService.applyTheme('dark-gold');
  }

  ngOnInit() {

  }

  onLogin() {
    console.log('working');

    this.router.navigateByUrl('login');
  }



}
